import { useEffect } from 'react';

export const useRefreshOnRotate = () => {
    useEffect(() => {
        const handleOrientationChange = () => {
            const url = new URL(window.location.href);
            if (url.searchParams.has('modal-video')) {
                return;
            }
            window.location.reload();
        };

        window.addEventListener('orientationchange', handleOrientationChange);
        return () => {
            window.removeEventListener(
                'orientationchange',
                handleOrientationChange,
            );
        };
    }, []);
};
